/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import MathQuill from 'legacy-lib/mathquill-patch';

class LatexKeypadButton extends Component {
  componentDidMount() {
    MathQuill.StaticMath(this.latex);
  }

  render() {
    const value = this.props.value || this.props.label;

    // TODO remove static-math class
    return (
      <button className="button-legacy" value={value}>
        <span
          className="static-math"
          ref={(c) => {
            this.latex = c;
          }}
        >
          {this.props.label}
        </span>
      </button>
    );
  }
}

export default LatexKeypadButton;
